import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Calories from 'pages/menu/menu-modal/calories/calories.component';
import * as S from './menu-card-new-item-content.styles';
import MenuCardNewItemContentPrice from './menu-card-new-item-content-price/menu-card-new-item-content-price.component';

const MenuCardNewItemContent = ({
  title,
  price,
  description,
  calories,
  catalogExtendedAttributes,
}) => {
  const titleRef = useRef(null);
  const [lineHeight, setLineHeight] = useState(0);

  useEffect(() => {
    setLineHeight(titleRef.current.offsetHeight);
  }, []);

  const showingCalories =
    catalogExtendedAttributes?.DISPLAY_CALORIES?.toString().toLowerCase() ===
      'true' && calories != null;

  return (
    <S.TopContainer data-testid="MenuCard.Content.Container">
      <S.InnerContainer>
        <S.Title component="h3" data-testid="MenuCard.Title" ref={titleRef}>
          {title}
        </S.Title>
        <MenuCardNewItemContentPrice price={price} />
      </S.InnerContainer>
      <S.Description
        data-testid="MenuCard.Description"
        $lineHeight={lineHeight}
        $showingCalories={showingCalories}
      >
        {description}
      </S.Description>
      <Box sx={{ mt: 'auto' }}>
        <Calories
          catalogExtendedAttributes={catalogExtendedAttributes}
          calories={calories}
          mainItem
          showDisclaimer={false}
        />
      </Box>
    </S.TopContainer>
  );
};

export default MenuCardNewItemContent;
